import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getIn } from 'formik';
import uniq from 'lodash/uniq';
import values from 'lodash/values';
import { styled } from '@mui/system';
import MuiGrid from '@mui/material/Grid';
import Typography from '@cpg-its/ads.common.typography';
import { red, white } from '@cpg-its/ads.constants.colors';
const errorStyles = {
    checkBox: {},
    datePicker: {
        bottom: 56,
        left: 24,
    },
    input: {},
    radioGroup: {
        marginTop: 0,
    },
    percentInput: {
        bottom: 24,
        float: 'none',
        marginBottom: '-24px',
        padding: '1px 8px',
        width: 'max-content',
    },
    searchSuggest: {
        zIndex: 3,
    },
};
const Arrow = styled(MuiGrid)({
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: 6,
    borderColor: `transparent transparent ${red} transparent`,
    position: 'relative',
    left: 16,
});
const ErrorWrapper = styled(MuiGrid)({
    background: red,
    borderRadius: 3,
    padding: 8,
});
export const ErrorMessageComponent = ({ component, errors = {}, name, searchSuggest, testId, touched, }) => {
    const touch = name ? getIn(touched, name) : false;
    const error = name ? getIn(errors, name) || [] : [];
    const formatErrors = (() => {
        if (typeof error === 'string') {
            return [error];
        }
        if (values(error).length) {
            return uniq(values(error));
        }
        return error;
    })();
    const renderErrors = (() => (formatErrors.map((err) => (_jsx(MuiGrid, { item: true, xs: 12, children: _jsx(Typography, { text: err, color: white, size: "small" }) }, err)))))();
    if (touch && formatErrors.length) {
        return (_jsxs(_Fragment, { children: [_jsx(Arrow, {}), _jsx(ErrorWrapper, { sx: [
                        component ? errorStyles[component] : {},
                        searchSuggest ? errorStyles.searchSuggest : {},
                    ], container: true, "data-testid": testId, children: renderErrors })] }));
    }
    return null;
};
export default ErrorMessageComponent;
//# sourceMappingURL=error-message.js.map